<template>
  <modal id="editOrDeleteShift" v-cloak>
    <div slot="title">
      <h3>Wilt u volgende shift verwijderen/aanpassen?</h3>
      <h3>{{ this.currentCalendarEntry.title }}</h3>
      <h4>Kies je shift</h4>
    </div>
    <div slot="body" class="card">
      <div class="card-body">
        <div class="row justify-content-center">
          <button
              v-for="shiftType in contract.shiftTypes" :key="shiftType.id"
              :value="shiftType.id" @click="handleSelection"
              :style="{
                         'color' : giveTextColorForBackGroundColor(shiftType.color),
                         'background-color': shiftType.color,
                         'border-color': shiftType.color }"
              class="btn">
            {{ shiftType.name }}
          </button>
        </div>
      </div>
      <div slot="footer">
        <button
            class="btn btn-danger"
            @click="handleDeleteShift">
          Verwijder Shift
        </button>
      </div>
    </div>
  </modal>
</template>
<script>

import {VoerroModal} from "@voerro/vue-modal";
import moment from "moment";
import {mapActions} from "vuex";
import {giveTextColorForBackGroundColor} from "@/util/ColorUtil";
import {toYearAndMonth} from "@/util/DateUtil";

export default {
  name: "editOrDeleteEventModal",
  props: ['currentCalendarEntry', 'contract'],
  data: () => ({
    absenceDate: {},
    absenceType: {},
  }),
  methods: {
    ...mapActions("timesheet", ['deletePlannedShift', 'updatePlannedShift']),
    handleSelection(arg) {
      const shiftId = arg.target.value;
      const dateToMoment = moment(this.currentCalendarEntry.start).locale('nl');
      const id = this.currentCalendarEntry.id;
      this.putEvent(dateToMoment, shiftId, id);
      VoerroModal.hide("editOrDeleteShift");
    },
    handleDeleteShift() {
      const yearMonth = toYearAndMonth(this.currentCalendarEntry.start);
      const deletePlannedShiftDto = {
        dayOfMonth: Number.parseInt(moment(this.currentCalendarEntry.start).format("DD"))
      };
      const contractId = this.contract.id;
      this.deletePlannedShift({
        contractId,
        yearMonth,
        deletePlannedShiftDto
      });
      VoerroModal.hide("editOrDeleteShift");
    },
    putEvent(dateToMoment, shiftId) {
      const editPlannedShiftDto = {
        startDate: dateToMoment.format("YYYY-MM-DD"),
        shiftId
      };
      const yearMonth = toYearAndMonth(dateToMoment);
      this.updatePlannedShift({
        yearMonth,
        editPlannedShiftDto
      });
    },
    giveTextColorForBackGroundColor(color) {
      return giveTextColorForBackGroundColor(color);
    }
  }
};
</script>

<style scoped>

</style>